// TODO: Fix all linting warnings in layout-lib #36010
/* eslint-disable */
import { Router, UrlSegment, PRIMARY_OUTLET } from '@angular/router';
import { RenderableMenu } from './renderable-menu.model';

export class RenderableMenuHelper {
  /** Constructs the routerlink command array based on this menu item based and its parent routerlink command array. */
  public static constructRouterLink(currentRouterLinkArray: any[], parentRouterLinkArray: any[]): any[] {
    if (!parentRouterLinkArray || parentRouterLinkArray.length === 0) {
      // No parent router link available, so just return the current router link.
      return currentRouterLinkArray;
    }

    const lastParentRouterLinkItemIndex = parentRouterLinkArray.length - 1;
    const lastParentRouterLinkItem = parentRouterLinkArray[lastParentRouterLinkItemIndex];

    if (lastParentRouterLinkItem.outlets) {
      // The parent router link has a outlet configuration. Merge this router link into the outlet(s).
      const outlets = {};
      Object.keys(lastParentRouterLinkItem.outlets).forEach((outletKey) => {
        const outletRouterLink = RenderableMenuHelper.getRouterLinkArray(lastParentRouterLinkItem.outlets[outletKey]);
        outlets[outletKey] = (RenderableMenuHelper.getRouterLinkArray(outletRouterLink) || []).concat(
          currentRouterLinkArray
        );
      });

      const resultRouterLinkArray: any[] = (parentRouterLinkArray || []).concat([]);
      resultRouterLinkArray.pop();
      resultRouterLinkArray.push({ outlets: outlets });

      return resultRouterLinkArray;
    }

    return (parentRouterLinkArray || []).concat(currentRouterLinkArray);
  }

  /** Gets the routerlink command array for the given routerlink, which can be either a string or already a routerlink command array. */
  public static getRouterLinkArray(routerLink: string | any[]): any[] {
    return typeof routerLink !== 'object' ? [routerLink] : <any[]>routerLink;
  }

  /** Gets whether each part of the menu item is contained in the current url. */
  public static isItemMatched(router: Router, menuItem: RenderableMenu, currentUrl: string): boolean {
    const currentUrlTree = router.parseUrl(currentUrl);
    const menuItemOutletKeys: string[] = RenderableMenuHelper.getOutletKeys(menuItem);

    if (menuItemOutletKeys.length === 0) {
      return !currentUrlTree.root.hasChildren() || !currentUrlTree.root.children[PRIMARY_OUTLET];
    }

    return menuItemOutletKeys.every((outlet) => {
      const menuItemOutlet = menuItem.urlTree.root.hasChildren() ? menuItem.urlTree.root.children[outlet] : undefined;
      const currentUrlOutlet = currentUrlTree.root.hasChildren() ? currentUrlTree.root.children[outlet] : undefined;

      if (!menuItemOutlet || !currentUrlOutlet) {
        return !menuItemOutlet && !currentUrlOutlet;
      }

      const equalSegmentCount = menuItemOutlet.segments.length === currentUrlOutlet.segments.length;
      const equalSegments = menuItemOutlet.segments.every((value: UrlSegment, index: number) =>
        RenderableMenuHelper.isIdenticalUrlSegment(currentUrlOutlet.segments[index], value)
      );

      // Only check whether the query parameters match if the segment count matches.
      if (equalSegments && equalSegmentCount) {
        return RenderableMenuHelper.containsEqualQueryParams(menuItem, router, currentUrl);
      }

      return equalSegments;
    });
  }

  /** Gets whether the menu item matches each part of the contained url. */
  public static isItemActive(router: Router, menuItem: RenderableMenu, currentUrl: string): boolean {
    const currentUrlTree = router.parseUrl(currentUrl);
    const menuItemOutletKeys: string[] = RenderableMenuHelper.getOutletKeys(menuItem);

    if (menuItemOutletKeys.length === 0) {
      return !currentUrlTree.root.hasChildren() || !currentUrlTree.root.children[PRIMARY_OUTLET];
    }

    const containsEqualSegments = menuItemOutletKeys.every((outlet) => {
      const menuItemOutlet = menuItem.urlTree.root.hasChildren() ? menuItem.urlTree.root.children[outlet] : undefined;
      const currentUrlOutlet = currentUrlTree.root.hasChildren() ? currentUrlTree.root.children[outlet] : undefined;

      if (!menuItemOutlet || !currentUrlOutlet) {
        return !menuItemOutlet && !currentUrlOutlet;
      }

      const equalSegmentCount = menuItemOutlet.segments.length === currentUrlOutlet.segments.length;
      const equalSegments = currentUrlOutlet.segments.every((value: UrlSegment, index: number) =>
        RenderableMenuHelper.isIdenticalUrlSegment(menuItemOutlet.segments[index], value)
      );
      return equalSegmentCount && equalSegments;
    });

    const containsEqualQueryParams = RenderableMenuHelper.containsEqualQueryParams(menuItem, router, currentUrl);
    return containsEqualSegments && containsEqualQueryParams;
  }

  private static getOutletKeys(menuItem: RenderableMenu): string[] {
    const outletKeys = Object.keys(menuItem.urlTree.root.children);
    return outletKeys.filter(
      (outletKey) =>
        menuItem.routerLink.findIndex(
          (command) =>
            (!command.outlets && outletKey === PRIMARY_OUTLET) ||
            (command.outlets && command.outlets[outletKey]) !== undefined
        ) > -1
    );
  }

  private static isIdenticalUrlSegment(segment1: UrlSegment, segment2: UrlSegment) {
    return segment1 && segment1.path === segment2.path;
  }

  private static containsEqualQueryParams(menuItem: RenderableMenu, router: Router, currentUrl: string): boolean {
    return (
      !(menuItem.navigationExtras && menuItem.navigationExtras.queryParams) ||
      RenderableMenuHelper.hasEqualQueryParamsForItem(router, currentUrl, menuItem)
    );
  }

  private static hasEqualQueryParamsForItem(router: Router, currentUrl: string, menuItem: RenderableMenu) {
    const currentUrlTree = router.parseUrl(currentUrl);
    const menuItemUrlTree = menuItem.urlTree;
    return menuItemUrlTree.queryParamMap.keys.every(
      (paramKey) =>
        menuItemUrlTree.queryParamMap
          .getAll(paramKey)
          .map((paramValue) => currentUrlTree.queryParamMap.getAll(paramKey).findIndex((x) => x === paramValue) >= 0)
          .indexOf(false) === -1
    );
  }
}
